import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { getKeyIndicators } from '@/api/dashboard/dashboard.api';
import { useCompanyStore, useToastSnackbarStore } from '@/stores';

import type { IKeyIndicatorsType } from '@/types/dashboard.types';
import { ToastType } from '@/types/toastSnackbar.type';

export default defineStore('dashboard', () => {
  const { t } = useI18n();

  const companyStore = useCompanyStore();
  const toastSnackbarStore = useToastSnackbarStore();

  const isKeyIndicatorsLoading = ref(false);
  const hasKeyIndicatorsError = ref(false);
  const keyIndicators = ref<IKeyIndicatorsType | null>(null);

  const fetchKeyIndicators = async () => {
    hasKeyIndicatorsError.value = false;
    isKeyIndicatorsLoading.value = true;

    await getKeyIndicators(companyStore.currentUserCompany?.id || '')
      .then(data => {
        keyIndicators.value = data;
      })
      .catch(() => {
        hasKeyIndicatorsError.value = true;
        toastSnackbarStore.addToast({
          id: 'get-key-indicators-error',
          title: t('errors.getKeyIndicators'),
          isClosable: true,
          timer: 6000,
          toastType: ToastType.Error,
        });
      })
      .finally(() => {
        isKeyIndicatorsLoading.value = false;
      });
  };
  return {
    // Refs
    keyIndicators,
    isKeyIndicatorsLoading,
    // Methods
    fetchKeyIndicators,
  };
});
